import api from "./api";
import { API_URLS } from "../App";
import { useAuth } from "../context/AuthContext";

interface UseLoginResult {
  isLoading: boolean;
  error: string | null;
  login: (request: LoginRequest) => Promise<ProfileAndSettings | undefined>;
  logout: () => Promise<void>;
}

export const useLogin = (
  setIsLoading: (isLogin: boolean) => void,
  setError: (error: any | null) => void,
) => {
  const { setProfile } = useAuth();
  const login = async (loginRequest: LoginRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await api.post(API_URLS.LOGIN, loginRequest);
      const data: ProfileAndSettings = await response.data;
      if (!data) {
        throw new Error("Login failed: No data received");
      }
      setProfile(data);
      return data;
    } catch (err: any) {
      setError(err || new Error("An error occurred during login"));
    } finally {
      setIsLoading(false);
    }
  };

  const logout = async () => {
    setIsLoading(true);
    setError(null);

    try {
      // @ts-ignore
      await api.clearToken();
      setProfile(null);
    } catch (err: any) {
      setError(err || new Error("An error occurred during logout"));
    } finally {
      setIsLoading(false);
    }
  };
  return { login, logout };
};
